import { GateWay, Category } from '../gateway.model';
import { GateWayMibActionTypes, GateWayMibActions } from '../actions/gateway-mib.actions';

export interface State {
  Loaded: boolean;
  Loading: boolean;
  entities: any;
}

export const initialMgtMibTrapListState: State = {
  Loaded: false,
  Loading: false,
  entities: null
};

export interface GateWayMgtMibTrapListState {
  Loaded: boolean;
  Loading: boolean;
  entities: any;
}

export interface GateWayMibTrapListState {
  Loaded: boolean;
  Loading: boolean;
  entities: any;
}

export const initialMibTrapListState: GateWayMibTrapListState = {
  Loaded: false,
  Loading: false,
  entities: null
};

export interface GateWayMgtMibDetailState {
  Loaded: boolean;
  Loading: boolean;
  entities: any;
}

export const initialMgtMibDetailState: GateWayMgtMibDetailState = {
  Loaded: false,
  Loading: false,
  entities: null
};
export interface GateWayMibDetailState {
  Loaded: boolean;
  Loading: boolean;
  entities: any;
}

export const initialMibDetailState: GateWayMibDetailState = {
  Loaded: false,
  Loading: false,
  entities: null
};

export interface GateWayCategoryListState {
  Loaded: boolean;
  Loading: boolean;
  entities: Category[] | null;
}

export const initialCategoryListState: GateWayCategoryListState = {
  Loaded: false,
  Loading: false,
  entities: null
};

export function reducer(
  state = initialMgtMibTrapListState,
  action: GateWayMibActions
): GateWayMgtMibTrapListState {
  switch (action.type) {

    case GateWayMibActionTypes.UpsertMgtMibTrapList: {
      return {...state, Loaded: true, Loading: false, entities: action.payload};
    }

    case GateWayMibActionTypes.ReadMgtMibTrapList: {
      return {...state, Loaded: false, Loading: true, entities: action.payload};
    }

    case GateWayMibActionTypes.ReadMgtMibTrapListFail: {
      return {...state, Loaded: true, Loading: false, entities: action.payload};
    }

    default: {
      return state;
    }
  }
}
export function mibTrapListReducer(state = initialMibTrapListState, action: GateWayMibActions): GateWayMibTrapListState {
  switch (action.type) {
    case GateWayMibActionTypes.ReadMibTrapList:
      return {...state, Loaded: false, Loading: true};

    case GateWayMibActionTypes.UpsertMibTrapList:
      return {...state, Loaded: true, Loading: false, entities: action.payload};

    case GateWayMibActionTypes.ReadMibTrapListFail: {
      return {...state, Loaded: true, Loading: false};
    }

    default:
      return state;
  }
}

export function mgtMibDetailReducer(state = initialMgtMibDetailState, action: GateWayMibActions): GateWayMgtMibDetailState {
  switch (action.type) {
    case GateWayMibActionTypes.ReadMgtMibDetail:
      return {...state, Loaded: false, Loading: true};

    case GateWayMibActionTypes.UpsertMgtMibDetail:
      return {...state, Loaded: true, Loading: false, entities: action.payload};

    case GateWayMibActionTypes.ReadMgtMibDetailFail: {
      return {...state, Loaded: true, Loading: false};
    }

    default:
      return state;
  }
}

export function mibDetailReducer(state = initialMibDetailState, action: GateWayMibActions): GateWayMibDetailState {
  switch (action.type) {
    case GateWayMibActionTypes.ReadMibDetail:
      return {...state, Loaded: false, Loading: true};

    case GateWayMibActionTypes.UpsertMibDetail:
      return {...state, Loaded: true, Loading: false, entities: action.payload};

    case GateWayMibActionTypes.ReadMibDetailFail: {
      return {...state, Loaded: true, Loading: false};
    }

    default:
      return state;
  }
}

export function categoryListReducer(state = initialCategoryListState, action: GateWayMibActions): GateWayCategoryListState {
  switch (action.type) {
    case GateWayMibActionTypes.ReadCategoryListByUser:
      return {...state, Loaded: false, Loading: true};

    case GateWayMibActionTypes.UpsertCategoryListByUser:
      return {...state, Loaded: true, Loading: false, entities: action.payload};

    case GateWayMibActionTypes.ReadCategoryListByUserFail: {
      return {...state, Loaded: true, Loading: false};
    }

    default:
      return state;
  }
}

export const getGateWayMgtMibTrapListState = (state: GateWayMgtMibTrapListState) => state;
export const getGateWayMgtMibDetailState = (state: GateWayMgtMibDetailState) => state;
export const getGateWayMibTrapListState = (state: GateWayMibTrapListState) => state;
export const getGateWayMibDetailState = (state: GateWayMibDetailState) => state;
export const getGateWayCategoryListState = (state: GateWayCategoryListState) => state;
